import { render } from "./daytwo.vue?vue&type=template&id=c1ab163c"
import script from "./daytwo.vue?vue&type=script&lang=js"
export * from "./daytwo.vue?vue&type=script&lang=js"

import "./daytwo.vue?vue&type=style&index=0&id=c1ab163c&lang=scss"
script.render = render

export default script